var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Breadcrumb',{attrs:{"items":_vm.breadcrumbs}}),_c('ElementoForm',{on:{"save":_vm.handleSave,"cancel":_vm.handleCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }